export enum RiskScale {
    'NONE' = 0,
    'MILD' = 1,
    'SEVERE' = 2
}

export enum CreditUnions {
    EXPERIAN = 'XPN',
    TRANS_UNION = 'TU',
    EQUIFAX = 'EFX',
    CLARITY_SERVICES = 'CL',
    TRI_MERGE = 'XPN|TU|EFX'
}